var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdobeConnect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.5C5.20101 21.5 0.5 16.799 0.5 11C0.5 5.20101 5.20101 0.5 11 0.5C16.799 0.5 21.5 5.20101 21.5 11C21.5 16.799 16.799 21.5 11 21.5Z",
    fill: "url(#paint0_radial_1310_6512)",
    stroke: "#4FC495"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08072 12.8213H5.18344V16.8278H9.08072V12.8213Z",
    fill: "#4FC495"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2348 13.2325H13.1386V16.4155H16.2348V13.2325Z",
    fill: "#4FC495"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2348 5.45245H13.1386V8.63542H16.2348V5.45245Z",
    fill: "#4FC495"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68072 5.46664H5.58456V8.64961H8.68072V5.46664Z",
    fill: "#4FC495"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2348 5.45244V8.63364L9.98575 11.8889L13.141 5.45244H16.2348ZM16.6348 5.04123H12.8947L9.08073 12.8213L16.6348 8.88626V5.04123Z",
    fill: "#D3EEE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2348 13.2325V16.4166H13.144L10.0465 13.2325H16.2348ZM16.6348 12.8213H9.08075L12.9783 16.8278H16.6348V12.8213Z",
    fill: "#D3EEE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68073 5.4666V11.8284L5.58344 8.64406V5.4666H8.68073ZM9.08073 5.05539H5.18344V8.81437L9.08072 12.8212V5.05539H9.08073Z",
    fill: "#D3EEE5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1310_6512",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.77105 7.32848) scale(14.3432 14.7453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2017",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    stopColor: "#071A13"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeConnect);
export default __webpack_public_path__ + "static/media/AdobeConnect.ec62fa2c03e34f306daf55d2f38b6933.svg";
export { ForwardRef as ReactComponent };